<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="idsModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">Add {{type}} IDs</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section v-if="!loading">
              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent="addMoreIDs">
                    <div class="row">
                      <div class="col-md-12">
                        <label>IDs:</label>
                        <textarea class="form-control" rows="3" v-model="ids"></textarea>
                      </div>
                    </div>
                    <button class="btn btn-sm btn-primary float-right" type="submit">Submit</button>
                  </form>
                </div>
              </div>
            </section>
            <div v-else class="loader"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db, storage} from "@/firebase/init"
export default {
  name: "checklistCommentsModal",
  data () {
    return {
      ids: '',
      loading: false,
      type: '',
      task: null
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    load (type, task) {
      console.log(type, task.cssIds, task.jssIds)
      this.type = type
      this.task = task
      if (type === 'css' && task.cssIds) {
        this.ids = task.cssIds.join('\n')
      } else if (type === 'js' && task.jssIds) {
        this.ids = task.jssIds.join('\n')
      }
      $('#idsModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async addMoreIDs () {
      if (this.ids) {
        this.loading = true
        try {
          const newIds = this.ids.split('\n').filter(line => line.trim() !== '');
          if (this.type === 'css') {
            await db.collection('CFEnterpriseRequests').doc(this.task.docId).update({
              cssIds: newIds
            })
          } else if (this.type === 'js') {
            await db.collection('CFEnterpriseRequests').doc(this.task.docId).update({
              jssIds: newIds
            })
          }
        } catch (e) {
          console.log('error', e.toString())
        }
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.image-div {
  background-color: rgba(0,0,0, 0.1);
  border: 1px solid rgba(0,0,0, 0.3);
  width: 100%;
  height: 170px;
  .preview {
    img {
      height: 100px;
    }

  }
}
.w-150 {
  width: 150px;
}
.remove-image-btn {
  background-color: #ef8057;
  border: 1px solid rgba(0,0,0, 0.3);
}
</style>
